export enum ReportTypeENum {
    DAYWISE = 'DAYWISE',
    WEEKWISE = 'WEEKWISE',
    QUARTERWISE = 'QUARTERWISE'
  }
